<template>
  <div class="areaPage">
    <van-tabs v-model="active" swipeable class="areaTab">
      <van-tab title="省级" name="province" class="tabList">
        <div class="provinceBox">
          <!-- 没有数据 -->
          <p class="kongSoure" v-if="provinceData == ''">无匹配数据</p>
          <van-radio-group
            v-model="provinceRadio"
            :disabled="disabledCode.length > 1"
          >
            <van-cell-group>
              <van-cell
                v-for="(item, index) in provinceData"
                :key="item.code"
                :title="`${item.zqName}`"
                clickable
                @click="
                  disabledCode.length > 1
                    ? ''
                    : getCityData(active, item, index)
                "
              >
                <van-radio
                  slot="right-icon"
                  checked-color="#4ac08a"
                  :name="index"
                />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-tab>
      <van-tab title="市级" name="city" class="tabList">
        <div class="cityBox">
          <!-- 没有数据 -->
          <p class="kongSoure" v-if="cityData == ''">无匹配数据</p>
          <van-radio-group
            v-model="cityRadio"
            :disabled="disabledCode.length > 1"
          >
            <van-cell-group>
              <van-cell
                title="全部"
                @click="getClear('2')"
                v-if="selectType == 'portion' && cityData != ''"
              >
                <van-radio
                  slot="right-icon"
                  checked-color="#4ac08a"
                  :name="'none'"
                />
              </van-cell>
              <van-cell
                v-for="(item, index) in cityData"
                :key="item.code"
                :title="`${item.zqName}`"
                clickable
                @click="
                  disabledCode.length > 3
                    ? ''
                    : getAreaData(active, item, index)
                "
              >
                <van-radio
                  slot="right-icon"
                  checked-color="#4ac08a"
                  :name="index"
                />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-tab>
      <van-tab title="区级" name="area" class="tabList">
        <div class="areaBox">
          <!-- 没有数据 -->
          <p class="kongSoure" v-if="areaData == ''">无匹配数据</p>
          <van-radio-group
            v-model="areaRadio"
            :disabled="disabledCode.length > 5"
          >
            <van-cell-group>
              <van-cell
                title="全部"
                @click="getClear('3')"
                v-if="selectType == 'portion' && areaData != ''"
              >
                <van-radio
                  slot="right-icon"
                  checked-color="#4ac08a"
                  :name="'none'"
                />
              </van-cell>
              <van-cell
                v-for="(item, index) in areaData"
                :key="item.code"
                :title="`${item.zqName}`"
                clickable
                @click="
                  disabledCode.length > 5
                    ? ''
                    : getTownshipData(active, item, index)
                "
              >
                <van-radio
                  slot="right-icon"
                  checked-color="#4ac08a"
                  :name="index"
                />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-tab>
      <van-tab title="镇/乡级" name="township" class="tabList">
        <div class="townshipBox">
          <!-- 没有数据 -->
          <p class="kongSoure" v-if="townshipData == ''">无匹配数据</p>
          <van-radio-group
            v-model="townshipRadio"
            :disabled="disabledCode.length > 8"
          >
            <van-cell-group>
              <van-cell
                title="全部"
                @click="getClear('4')"
                v-if="selectType == 'portion' && townshipData != ''"
              >
                <van-radio
                  slot="right-icon"
                  checked-color="#4ac08a"
                  :name="'none'"
                />
              </van-cell>
              <van-cell
                v-for="(item, index) in townshipData"
                :key="item.code"
                :title="`${item.zqName}`"
                clickable
                @click="
                  disabledCode.length > 8
                    ? ''
                    : getvillageData(active, item, index)
                "
              >
                <van-radio
                  slot="right-icon"
                  checked-color="#4ac08a"
                  :name="index"
                />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-tab>
      <van-tab title="村级" name="village" class="tabList">
        <div class="areaBox">
          <!-- 没有数据 -->
          <p class="kongSoure" v-if="villageData == ''">无匹配数据</p>
          <van-radio-group
            v-model="villageRadio"
            :disabled="disabledCode.length > 11"
          >
            <van-cell-group>
              <van-cell
                title="全部"
                @click="getClear('5')"
                v-if="selectType == 'portion' && villageData != ''"
              >
                <van-radio
                  slot="right-icon"
                  checked-color="#4ac08a"
                  :name="'none'"
                />
              </van-cell>
              <van-cell
                v-for="(item, index) in villageData"
                :key="item.code"
                :title="`${item.zqName}`"
                clickable
                @click="disabledCode.length > 11 ? '' : getcheck(item, index)"
              >
                <van-radio
                  slot="right-icon"
                  checked-color="#4ac08a"
                  :name="index"
                />
              </van-cell>
            </van-cell-group>
          </van-radio-group>
        </div>
      </van-tab>
    </van-tabs>
    <div class="checkedValue">
      <van-cell-group>
        <van-field
          v-model="checkedValue"
          rows="1"
          readonly
          autosize
          label="选中值："
          type="textarea"
          placeholder
        />
      </van-cell-group>
    </div>
    <!-- 操作按钮 -->
    <div class="btnBox clearfix">
      <a href="javascript:void(0);" class="closeBtn" @click="closePicker(1)"
        >取消</a
      >
      <a href="javascript:void(0);" class="sureBtn" @click="closePicker(2)"
        >确定</a
      >
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
export default {
  name: "areaSelect",
  props: {
    areaSource: {
      type: Object,
      default: () => {
        return {};
      },
    },
    selectType: {
      type: String,
    },
  },
  data() {
    return {
      disabledCode: "", //禁止点击的code
      active: "province",
      topParentCode: "",
      provinceData: "", //省数据源
      cityData: "", //市数据源
      areaData: "", //区数据源
      townshipData: "", //乡镇数据源
      villageData: "", //村数据源
      checkedValue: "", //选中值
      checkedCode: "",
      provinceRadio: "", //省选中高亮
      cityRadio: "", //市选中高亮
      areaRadio: "", //区选中高亮
      townshipRadio: "", //乡镇选中高亮
      villageRadio: "", //村选中高亮
      showKong: false, //没有内容展示
    };
  },
  mounted() {
    this.getTreeLogin();
    this.$nextTick(function () {
      if (this.areaSource.regionCode) {
        this.checkedValue = this.areaSource.regionCodeName;
        this.checkedCode = this.areaSource.regionCode;
        this.getSourceData(this.active, this.topParentCode, "1");
        let citySource = this.areaSource.regionCode.substring(0, 2);
        this.getSourceData("city", citySource, "2"); //加载全国市级数据
        let areaSource = this.areaSource.regionCode.substring(0, 4);
        this.getSourceData("area", areaSource, "3"); //加载区级数据
        let townshipSource = this.areaSource.regionCode.substring(0, 6);
        this.getSourceData("township", townshipSource, "4"); //加载乡镇数据
        let villageSource = this.areaSource.regionCode.substring(0, 9);
        this.getSourceData("village", villageSource, "5"); //加载村数据
      } else {
        this.getSourceData(this.active, this.topParentCode, "1");
        this.checkedValue = "";
        this.checkedCode = "";
      }
    });
  },
  methods: {
    //初始化表单==>新增时
    getTreeLogin() {
      let _this = this;
      _this.$api.slbkOldTree
        .getLogin()
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.disabledCode = res.data.zqCode ? res.data.zqCode : "";
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSourceData(name, parentCode, depth) {
      let _this = this;
      _this.$api.slbkOldTree
        .getTreeZqCode({
          zqCode: parentCode,
          depth: depth,
        })
        .then((res) => {
          if (res.code == "1") {
            if (res.data == [] || res.data == "") {
              _this.showKong = true;
            }
            if (name == "province") {
              //省级
              _this.provinceData = res.data;
              if (_this.areaSource.regionCode) {
                let provinceIndex = _this.areaSource.regionCode.substring(0, 2);
                _this.provinceData.forEach((item, index) => {
                  if (provinceIndex === _this.provinceData[index].zqCode) {
                    _this.provinceRadio = index;
                  }
                });
              }
            } else if (name == "city") {
              //市级
              _this.cityData = res.data[0].children;
              if (_this.areaSource.regionCode) {
                let cityIndex = _this.areaSource.regionCode.substring(0, 4);
                _this.cityData.forEach((item, index) => {
                  if (cityIndex === _this.cityData[index].zqCode) {
                    _this.cityRadio = index;
                  }
                });
              }
            } else if (name == "area") {
              //区级
              _this.areaData = res.data[0].children;
              if (_this.areaSource.regionCode) {
                let areaIndex = _this.areaSource.regionCode.substring(0, 6);
                _this.areaData.forEach((item, index) => {
                  if (areaIndex === _this.areaData[index].zqCode) {
                    _this.areaRadio = index;
                  }
                });
              }
            } else if (name == "township") {
              //乡镇级
              _this.townshipData = res.data[0].children;
              if (_this.areaSource.regionCode) {
                let townshipIndex = _this.areaSource.regionCode.substring(0, 9);
                _this.townshipData.forEach((item, index) => {
                  if (townshipIndex === _this.townshipData[index].zqCode) {
                    _this.townshipRadio = index;
                  }
                });
              }
            } else if (name == "village") {
              //村级
              _this.villageData = res.data[0].children;
              if (_this.areaSource.regionCode) {
                let villageIndex = _this.areaSource.regionCode;
                _this.villageData.forEach((item, index) => {
                  if (villageIndex === _this.villageData[index].zqCode) {
                    _this.villageRadio = index;
                  }
                });
              }
            } else {
              return;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getCityData(name, item, index) {
      //选择省级
      let _this = this;

      _this.provinceRadio = index;
      _this.active = "city";
      _this.checkedValue = item.zqName;
      _this.areaData = "";
      _this.townshipData = "";
      _this.villageData = "";
      _this.cityRadio = ""; //市选中高亮
      _this.areaRadio = ""; //区选中高亮
      _this.townshipRadio = ""; //乡镇选中高亮
      _this.villageRadio = ""; //村选中高亮
      _this.getSourceData(_this.active, item.zqCode, "2");
      _this.checkedCode = item.zqCode;
    },
    getAreaData(name, item, index) {
      //选择市级
      let _this = this;

      _this.cityRadio = index;
      _this.active = "area";
      _this.townshipData = "";
      _this.villageData = "";

      _this.areaRadio = ""; //区选中高亮
      _this.townshipRadio = ""; //乡镇选中高亮
      _this.villageRadio = ""; //村选中高亮
      _this.checkedValue = _this.checkedValue.split("/");
      _this.checkedValue = _this.checkedValue.splice(0, 1) + "/" + item.zqName;
      _this.getSourceData(_this.active, item.zqCode, "3");
      _this.checkedCode = item.zqCode;
    },
    getTownshipData(name, item, index) {
      //选择区级
      let _this = this;

      _this.areaRadio = index;
      _this.active = "township";
      _this.villageData = "";

      _this.townshipRadio = ""; //乡镇选中高亮
      _this.villageRadio = ""; //村选中高亮
      _this.checkedValue = _this.checkedValue.split("/");
      _this.checkedValue =
        _this.checkedValue.splice(0, 2).join("/") + "/" + item.zqName;
      _this.getSourceData(_this.active, item.zqCode, "4");
      _this.checkedCode = item.zqCode;
    },
    getvillageData(name, item, index) {
      //选择乡镇级

      let _this = this;
      _this.townshipRadio = index;

      _this.active = "village";
      _this.villageRadio = ""; //村选中高亮
      _this.checkedValue = _this.checkedValue.split("/");
      _this.checkedValue =
        _this.checkedValue.splice(0, 3).join("/") + "/" + item.zqName;
      _this.getSourceData(_this.active, item.zqCode, "5");
      _this.checkedCode = item.zqCode;
    },
    getcheck(item, index) {
      //选择村级
      let _this = this;

      _this.villageRadio = index;
      _this.checkedValue = _this.checkedValue.split("/");
      _this.checkedValue =
        _this.checkedValue.splice(0, 4).join("/") + "/" + item.zqName;
      _this.checkedCode = item.zqCode;
    },

    //清除选择状态
    getClear(activeIndex) {
      let _this = this;
      _this.checkedValue = _this.checkedValue.split("/");
      //删除当前所属状态
      switch (activeIndex) {
        case "1":
          _this.checkedValue = "全国"; //选中值
          _this.checkedCode = "";
          _this.provinceRadio = "none"; //省选中高亮
          _this.cityData = "";
          _this.areaData = "";
          _this.townshipData = "";
          _this.villageData = "";
          _this.cityRadio = ""; //市选中高亮
          _this.areaRadio = ""; //区选中高亮
          _this.townshipRadio = ""; //乡镇选中高亮
          _this.villageRadio = ""; //村选中高亮
          break;
        case "2":
          _this.cityRadio = "none"; //市选中高亮
          _this.areaData = "";
          _this.townshipData = "";
          _this.villageData = "";
          _this.areaRadio = ""; //区选中高亮
          _this.townshipRadio = ""; //乡镇选中高亮
          _this.villageRadio = ""; //村选中高亮
          _this.checkedValue = _this.checkedValue.splice(0, 1).join("/");
          _this.checkedCode = _this.checkedCode.substring(0, 2);

          break;
        case "3":
          _this.areaRadio = "none"; //区选中高亮
          _this.townshipData = "";
          _this.villageData = "";
          _this.townshipRadio = ""; //乡镇选中高亮
          _this.villageRadio = ""; //村选中高亮
          _this.checkedValue = _this.checkedValue.splice(0, 2).join("/");
          _this.checkedCode = _this.checkedCode.substring(0, 4);

          break;
        case "4":
          _this.townshipRadio = "none"; //乡镇选中高亮
          _this.villageRadio = ""; //村选中高亮
          _this.villageData = ""; //村选中高亮
          _this.checkedValue = _this.checkedValue.splice(0, 3).join("/");
          _this.checkedCode = _this.checkedCode.substring(0, 6);

          break;
        case "5":
          _this.villageRadio = "none"; //村选中高亮
          _this.checkedValue = _this.checkedValue.splice(0, 4).join("/");
          _this.checkedCode = _this.checkedCode.substring(0, 9);

          break;
        default:
          break;
      }
    },

    closePicker(type) {
      let getData = {};
      if (type == "1") {
        getData.type = false;
        this.$emit("setData", getData);
      } else {
        // console.log(this.checkedCode)
        getData.type = false;
        getData.code = this.checkedCode;
        getData.name = this.checkedValue;
        console.log(getData, "getData");
        if (this.selectType == "all" && this.checkedCode.length < 12) {
          this.$toast("所在地必须选择到最后一级！");
        } else {
          this.$emit("setData", getData);
        }
      }
    },
  },
};
</script>
<style lang="less">
@import "./css/checkSelect.less";
</style>